import { useEffect } from 'react';

import useAccountQuery from 'api/queries/useAccountQuery';
import useGlobalStore from 'hooks/useGlobalStore';
import { getAnonymousId } from 'utils/globalUtils';

/**
 * React hook to update the Split key for the Split client, as well as
 * the customer id stored in local storage. Updating the key will cause
 * the Split client to refetch all treatments for the new key value.
 */
const useSplitKeyReload = () => {
    const { setSplitKey } = useGlobalStore();
    const { data: account = {} } = useAccountQuery();

    useEffect(() => {
        const { customerID } = account ?? {};
        const localStorageCustomerID = localStorage.getItem('customerID');

        if (!customerID) {
            localStorage.removeItem('customerID');
            setSplitKey(getAnonymousId());
        }

        if (customerID && customerID !== localStorageCustomerID) {
            localStorage.setItem('customerID', customerID);
            setSplitKey(customerID.toString());
        }
    }, [account?.customerID]);
};

// eslint-disable-next-line import/prefer-default-export
export { useSplitKeyReload };
